import {useState, useEffect} from 'react'

// timeout is in (ms)
const useScroll = (ref, timeout = 2000) => {

    let scrollingTimeout = null
    const [isScrolling, setIsScrolling] = useState<boolean>(false)

    
    const handleScroll = (e) => {    
        setIsScrolling(true)          
        clearTimeout(scrollingTimeout)

        scrollingTimeout = setTimeout(() => {             
            setIsScrolling(false) 
        }, timeout)
    }

    useEffect(() => {
        return () => {
            clearTimeout(scrollingTimeout)
            ref?.removeEventListener('scroll', handleScroll);
        }
    }, [])

    useEffect(() => {
        if(ref) ref.addEventListener('scroll', handleScroll);
    }, [ref])
    
    return {isScrolling}
}

export {useScroll}